import OneSignal from "react-onesignal";
import OneSignalMobile from "onesignal-cordova-plugin";

import { env } from "../../env";
import isBrowser from "../../utils/isBrowser";
import { errorLog } from "../../utils/debugLog";

export const ONESIGNAL_USER = "OneSignalUser";

const initOneSignal = async () => {
  if (!env.ONE_SIGNAL) return;

  try {
    // Ensure this code runs only on the client side
    if (isBrowser()) {
      await OneSignal.init({
        appId: env.ONE_SIGNAL,
        // You can add other initialization options here
        // notifyButton: {
        //   enable: true,
        // },
      });
    } else {
      // Enable verbose logging for debugging (remove in production)
      OneSignalMobile.Debug.setLogLevel(6);

      // Initialize with your OneSignal App ID
      OneSignalMobile.initialize(env.ONE_SIGNAL);

      // Listener pour les notifications cliquées sur mobile
      OneSignalMobile.Notifications.addEventListener("click", (event) => {
        // Redirection vers le notification center
        const additionalData: any = event.notification.additionalData;
        if (additionalData?.redirectTo) {
          // Utiliser le routeur de ton app
          window.location.href = additionalData.redirectTo;
        } else {
          window.location.href = "/notifications";
        }
      });

      // Use this method to prompt for push notifications.
      // We recommend removing this method after testing and instead use In-App Messages to prompt for notification permission.

      OneSignalMobile.Notifications.requestPermission(false).then(
        (accepted: boolean) => {
          console.info("User accepted notifications: " + accepted);
        },
      );
    }
  } catch (err) {
    errorLog(err);
  }
};

export const setOneSignalUserId = async (userId: string) => {
  if (!env.ONE_SIGNAL) return;

  try {
    localStorage.setItem(ONESIGNAL_USER, userId);

    if (isBrowser()) {
      await OneSignal.login(userId);
    } else {
      await OneSignalMobile.login(userId);
    }
  } catch (err) {
    errorLog(err);
  }
};

export const clearOneSignalUser = async () => {
  if (!env.ONE_SIGNAL) return;

  try {
    localStorage.removeItem(ONESIGNAL_USER);

    if (isBrowser()) {
      await OneSignal.logout();
    } else {
      await OneSignalMobile.logout();
    }
  } catch (err) {
    errorLog(err);
  }
};

export default initOneSignal;
